var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "order-table" },
    [
      _vm.table
        ? _c(
            "el-table",
            {
              ref: "orderMultipleTable",
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.orderTableData,
                "max-height": "300",
                border: "",
                "show-summary": "",
                "summary-method": _vm.getSummaries,
                loading: _vm.loading
              },
              on: { "selection-change": _vm.selectOrder }
            },
            [
              _c("el-table-column", {
                attrs: { type: "selection", width: "55", fixed: "left" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  type: "index",
                  label: "序号",
                  width: "50",
                  fixed: "left"
                }
              }),
              _vm._v(" "),
              _vm.statusActive !== 6
                ? _c("el-table-column", {
                    attrs: {
                      prop: "created_at",
                      label: "推送日期",
                      width: "120"
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c(
                                "div",
                                {
                                  on: {
                                    click: function($event) {
                                      return _vm.getDetailTable(scope.row)
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n          " +
                                      _vm._s(scope.row.created_at) +
                                      "\n        "
                                  )
                                ]
                              )
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      893394313
                    )
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.isPingTai && _vm.statusActive === 6
                ? _c("el-table-column", {
                    attrs: { type: "created_at", label: "拒收日期" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c(
                                "div",
                                {
                                  on: {
                                    click: function($event) {
                                      return _vm.getDetailTable(scope.row)
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n          " +
                                      _vm._s(scope.row.created_at) +
                                      "\n        "
                                  )
                                ]
                              )
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      893394313
                    )
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.statusActive !== 6
                ? _c("el-table-column", {
                    attrs: { prop: "out_ware_day", label: "要求发货日" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c(
                                "div",
                                {
                                  on: {
                                    click: function($event) {
                                      return _vm.getDetailTable(scope.row)
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n          " +
                                      _vm._s(scope.row.out_ware_day) +
                                      "\n        "
                                  )
                                ]
                              )
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      3196603536
                    )
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.isFactory
                ? _c("el-table-column", {
                    attrs: { prop: "user_name", label: "客户姓名" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c(
                                "div",
                                {
                                  on: {
                                    click: function($event) {
                                      return _vm.getDetailTable(scope.row)
                                    }
                                  }
                                },
                                [
                                  _c("MaskViewVue", {
                                    attrs: {
                                      type: "maskName",
                                      maskVal: scope.row.user_name,
                                      customParams: {
                                        expand: JSON.stringify({
                                          xAPIVersion: "V1.0",
                                          xSystemID: "diablo"
                                        })
                                      }
                                    }
                                  })
                                ],
                                1
                              )
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      3620349255
                    )
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.isFactory
                ? _c("el-table-column", {
                    attrs: { prop: "mobile", label: "客户电话" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c(
                                "div",
                                {
                                  on: {
                                    click: function($event) {
                                      return _vm.getDetailTable(scope.row)
                                    }
                                  }
                                },
                                [
                                  _c("MaskViewVue", {
                                    attrs: {
                                      type: "maskPhone",
                                      maskVal: scope.row.mobile,
                                      customParams: {
                                        expand: JSON.stringify({
                                          xAPIVersion: "V1.0",
                                          xSystemID: "diablo"
                                        })
                                      }
                                    }
                                  })
                                ],
                                1
                              )
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      4281220405
                    )
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.isFactory
                ? _c("el-table-column", {
                    attrs: { prop: "address", label: "客户地址" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c(
                                "div",
                                {
                                  on: {
                                    click: function($event) {
                                      return _vm.getDetailTable(scope.row)
                                    }
                                  }
                                },
                                [
                                  _c("MaskViewVue", {
                                    attrs: {
                                      type: "maskAddress",
                                      maskVal: scope.row.address,
                                      customParams: {
                                        expand: JSON.stringify({
                                          xAPIVersion: "V1.0",
                                          xSystemID: "diablo"
                                        })
                                      }
                                    }
                                  })
                                ],
                                1
                              )
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      4001740169
                    )
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "main_number", label: "主订单号", width: "120" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function(scope) {
                        return [
                          _c(
                            "div",
                            {
                              staticClass: "detailTable",
                              on: {
                                click: function($event) {
                                  return _vm.getDetailTable(scope.row)
                                }
                              }
                            },
                            [
                              _c("span", [
                                _vm._v(_vm._s(scope.row.main_number))
                              ]),
                              _vm._v(" "),
                              scope.row.is_qp == 1
                                ? _c("span", [_vm._v("（紧急）")])
                                : _vm._e()
                            ]
                          )
                        ]
                      }
                    }
                  ],
                  null,
                  false,
                  948487858
                )
              }),
              _vm._v(" "),
              _vm.statusActive !== 1 &&
              _vm.statusActive !== 5 &&
              _vm.statusActive !== 6 &&
              _vm.isDeposit
                ? _c("el-table-column", {
                    attrs: {
                      prop: "order_tag",
                      label: "是否包含定金单",
                      width: "120"
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c(
                                "div",
                                {
                                  on: {
                                    click: function($event) {
                                      return _vm.getDetailTable(scope.row)
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n          " +
                                      _vm._s(
                                        scope.row.order_tag === "DEPOSIT_ORDER"
                                          ? "是"
                                          : "否"
                                      ) +
                                      "\n        "
                                  )
                                ]
                              )
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      1748263952
                    )
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.statusActive !== 5 && _vm.statusActive !== 6
                ? _c("el-table-column", {
                    attrs: {
                      prop: "shipping_delay_status_str",
                      label: "报备状态",
                      width: "80"
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c(
                                "div",
                                {
                                  on: {
                                    click: function($event) {
                                      return _vm.getDetailTable(scope.row)
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n          " +
                                      _vm._s(
                                        scope.row.shipping_delay_status_str
                                      ) +
                                      "\n        "
                                  )
                                ]
                              )
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      3337818490
                    )
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.statusActive !== 5 && _vm.statusActive !== 6
                ? _c("el-table-column", {
                    attrs: {
                      prop: "shipping_delay_status",
                      label: "报备类型",
                      width: "80"
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              scope.row.shipping_delay_status == -1 ||
                              scope.row.shipping_delay_status == 2
                                ? _c(
                                    "div",
                                    {
                                      on: {
                                        click: function($event) {
                                          return _vm.getDetailTable(scope.row)
                                        }
                                      }
                                    },
                                    [_vm._v("\n          延迟发货\n        ")]
                                  )
                                : _vm._e()
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      806319338
                    )
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.statusActive === 5
                ? _c("el-table-column", {
                    attrs: {
                      prop: "order_number",
                      label: "子订单号",
                      width: "140"
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c(
                                "div",
                                {
                                  staticClass: "detailTable",
                                  on: {
                                    click: function($event) {
                                      return _vm.getDetailTable(scope.row)
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n          " +
                                      _vm._s(scope.row.order_number) +
                                      "\n        "
                                  )
                                ]
                              )
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      1738559518
                    )
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.statusActive !== 6
                ? _c("el-table-column", {
                    attrs: {
                      prop: "serial_number",
                      label: "编号",
                      width: "140"
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              scope.row.serial_number
                                ? _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        scope.row.serial_number
                                          .split("-")
                                          .slice(3)
                                          .join("-")
                                      )
                                    )
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              scope.row.express && _vm.isZhifaOrFactory
                                ? _c("span", [
                                    _vm._v(
                                      "(" + _vm._s(scope.row.express) + ")"
                                    )
                                  ])
                                : _vm._e()
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      745650888
                    )
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "total_price", label: "订单总金额" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function(scope) {
                        return [
                          _c(
                            "div",
                            {
                              on: {
                                click: function($event) {
                                  return _vm.getDetailTable(scope.row)
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(
                                    _vm.statusActive !== 6
                                      ? scope.row.total_price
                                      : scope.row.buy_amount
                                  ) +
                                  "\n        "
                              )
                            ]
                          )
                        ]
                      }
                    }
                  ],
                  null,
                  false,
                  775466372
                )
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "total_amount", label: "订购总量" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function(scope) {
                        return [
                          _c(
                            "div",
                            {
                              on: {
                                click: function($event) {
                                  return _vm.getDetailTable(scope.row)
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(
                                    _vm.statusActive !== 6
                                      ? scope.row.total_amount
                                      : scope.row.buy_num
                                  ) +
                                  "\n        "
                              )
                            ]
                          )
                        ]
                      }
                    }
                  ],
                  null,
                  false,
                  1166783615
                )
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "total_send_amount", label: "实发总量" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function(scope) {
                        return [
                          _c(
                            "div",
                            {
                              on: {
                                click: function($event) {
                                  return _vm.getDetailTable(scope.row)
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(
                                    _vm.statusActive !== 6
                                      ? scope.row.total_send_amount
                                      : scope.row.send_num
                                  ) +
                                  "\n        "
                              )
                            ]
                          )
                        ]
                      }
                    }
                  ],
                  null,
                  false,
                  3854944686
                )
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "total_send_price", label: "实发总金额" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function(scope) {
                        return [
                          _c(
                            "div",
                            {
                              on: {
                                click: function($event) {
                                  return _vm.getDetailTable(scope.row)
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(
                                    _vm.statusActive !== 6
                                      ? scope.row.total_send_price
                                      : scope.row.send_amount
                                  ) +
                                  "\n        "
                              )
                            ]
                          )
                        ]
                      }
                    }
                  ],
                  null,
                  false,
                  1566545269
                )
              }),
              _vm._v(" "),
              _vm.statusActive == 6
                ? _c("el-table-column", {
                    attrs: { prop: "re_num", label: "拒收数量" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c(
                                "div",
                                {
                                  on: {
                                    click: function($event) {
                                      return _vm.getDetailTable(scope.row)
                                    }
                                  }
                                },
                                [_vm._v(_vm._s(scope.row.re_num))]
                              )
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      3880650237
                    )
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.statusActive == 6
                ? _c("el-table-column", {
                    attrs: { prop: "cfm_num", label: "确认数量" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c(
                                "div",
                                {
                                  on: {
                                    click: function($event) {
                                      return _vm.getDetailTable(scope.row)
                                    }
                                  }
                                },
                                [_vm._v(_vm._s(scope.row.cfm_num))]
                              )
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      2317919362
                    )
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.statusActive == 6
                ? _c("el-table-column", {
                    attrs: { prop: "cfm_amount", label: "确认金额" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c(
                                "div",
                                {
                                  on: {
                                    click: function($event) {
                                      return _vm.getDetailTable(scope.row)
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n          " +
                                      _vm._s(scope.row.cfm_amount) +
                                      "\n        "
                                  )
                                ]
                              )
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      3168186680
                    )
                  })
                : _vm._e(),
              _vm._v(" "),
              !_vm.isFactory && _vm.statusActive !== 6
                ? _c("el-table-column", {
                    attrs: { prop: "box_num", label: "打包箱数" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c(
                                "div",
                                {
                                  on: {
                                    click: function($event) {
                                      return _vm.getDetailTable(scope.row)
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "detailTable",
                                      on: {
                                        click: function($event) {
                                          return _vm.getBoxData(scope.row)
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n            " +
                                          _vm._s(scope.row.box_num)
                                      )
                                    ]
                                  )
                                ]
                              )
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      597077706
                    )
                  })
                : _vm._e(),
              _vm._v(" "),
              !_vm.isFactory && _vm.statusActive !== 6
                ? _c("el-table-column", {
                    attrs: { prop: "weight", label: "总称重(kg)" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c(
                                "div",
                                {
                                  on: {
                                    click: function($event) {
                                      return _vm.getDetailTable(scope.row)
                                    }
                                  }
                                },
                                [_vm._v(_vm._s(scope.row.weight))]
                              )
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      3148209859
                    )
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "od_statusName", label: "状态" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function(scope) {
                        return [
                          _vm.statusActive !== 6
                            ? _c(
                                "div",
                                {
                                  on: {
                                    click: function($event) {
                                      return _vm.getDetailTable(scope.row)
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n          " +
                                      _vm._s(scope.row.od_statusName) +
                                      "\n        "
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.statusActive === 6
                            ? _c(
                                "div",
                                {
                                  on: {
                                    click: function($event) {
                                      return _vm.getDetailTable(scope.row)
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n          " +
                                      _vm._s(
                                        _vm._f("filterR4RefuseStatus")(
                                          scope.row.status
                                        )
                                      ) +
                                      "\n        "
                                  )
                                ]
                              )
                            : _vm._e()
                        ]
                      }
                    }
                  ],
                  null,
                  false,
                  2880270854
                )
              }),
              _vm._v(" "),
              _vm.statusActive === 4 && _vm.isZhifaOrFactory
                ? _c("el-table-column", {
                    attrs: { prop: "box_status_msg", label: "物流状态" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c(
                                "div",
                                {
                                  on: {
                                    click: function($event) {
                                      return _vm.getDetailTable(scope.row)
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n          " +
                                      _vm._s(scope.row.box_status_msg) +
                                      "\n        "
                                  )
                                ]
                              )
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      2749995707
                    )
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.statusActive === 6
                ? _c("el-table-column", {
                    attrs: { prop: "showTime", label: "计时（拒收确认）" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c(
                                "div",
                                {
                                  on: {
                                    click: function($event) {
                                      return _vm.getDetailTable(scope.row)
                                    }
                                  }
                                },
                                [_vm._v(_vm._s(scope.row.showTime))]
                              )
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      3628936917
                    )
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.syncStatusFlag && _vm.statusActive !== 6
                ? _c("el-table-column", {
                    attrs: {
                      prop: "async_create_statusName",
                      label: "同步状态"
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c(
                                "el-button",
                                {
                                  attrs: { type: "text" },
                                  on: {
                                    click: function($event) {
                                      return _vm.getDetailAsyncStatus(scope.row)
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(scope.row.async_create_statusName)
                                  )
                                ]
                              )
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      2979680600
                    )
                  })
                : _vm._e(),
              _vm._v(" "),
              !_vm.isFactory && _vm.statusActive !== 6
                ? _c("el-table-column", {
                    attrs: { prop: "user_name", label: "客户" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c(
                                "div",
                                {
                                  on: {
                                    click: function($event) {
                                      return _vm.getDetailTable(scope.row)
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n          " +
                                      _vm._s(scope.row.user_name) +
                                      "\n        "
                                  )
                                ]
                              )
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      1765440586
                    )
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.statusActive === 1 ||
              _vm.statusActive === 2 ||
              _vm.statusActive === 3 ||
              _vm.statusActive === 4
                ? _c("el-table-column", {
                    attrs: { prop: "courier_number", label: "快递单号" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              scope.row.courier_number
                                ? _c(
                                    "div",
                                    {
                                      on: {
                                        click: function($event) {
                                          return _vm.getDetailTable(scope.row)
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n          " +
                                          _vm._s(scope.row.courier_number) +
                                          "\n        "
                                      )
                                    ]
                                  )
                                : _c(
                                    "div",
                                    {
                                      on: {
                                        click: function($event) {
                                          return _vm.getDetailTable(scope.row)
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n          " +
                                          _vm._s(
                                            _vm._f("courierNumberStatus")(
                                              scope.row.courier_number_status
                                            )
                                          ) +
                                          "\n        "
                                      )
                                    ]
                                  )
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      1537899621
                    )
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.isZhifaOrFactory &&
              (_vm.statusActive === 3 || _vm.statusActive === 4)
                ? _c("el-table-column", {
                    attrs: { prop: "express", label: "物流承运商" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c(
                                "div",
                                {
                                  on: {
                                    click: function($event) {
                                      return _vm.getDetailTable(scope.row)
                                    }
                                  }
                                },
                                [_vm._v(_vm._s(scope.row.express))]
                              )
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      2273473689
                    )
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.isZhifaOrFactory && _vm.statusActive === 3
                ? _c("el-table-column", {
                    attrs: { prop: "courier_mobile", label: "物流联系电话" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c(
                                "div",
                                {
                                  on: {
                                    click: function($event) {
                                      return _vm.getDetailTable(scope.row)
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n          " +
                                      _vm._s(scope.row.courier_mobile) +
                                      "\n        "
                                  )
                                ]
                              )
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      1089634089
                    )
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.isZhifaOrFactory && _vm.statusActive === 3
                ? _c("el-table-column", {
                    attrs: { prop: "serial_number", label: "查看子单号" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c(
                                "el-button",
                                {
                                  staticClass: "rejectOrder",
                                  attrs: { type: "text" },
                                  on: {
                                    click: function($event) {
                                      return _vm.getTransportDetail(scope.row)
                                    }
                                  }
                                },
                                [_vm._v("查看")]
                              )
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      3302591802
                    )
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.isZhifa && _vm.statusActive === 4 && _vm.canInputTs
                ? _c("el-table-column", {
                    attrs: {
                      prop: "ts_status",
                      label: "物流状态",
                      width: "110"
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _vm._v(
                                "\n        " +
                                  _vm._s(
                                    _vm._f("tsStatus")(scope.row.ts_status)
                                  ) +
                                  "\n      "
                              )
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      3462213051
                    )
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.isZhifaOrFactory && _vm.statusActive === 4 && _vm.canInputTs
                ? _c("el-table-column", {
                    attrs: { prop: "courier_type", label: "物流通知方式" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              scope.row.courier_type == 1
                                ? _c("span", [_vm._v("系统通知")])
                                : _vm._e(),
                              _vm._v(" "),
                              scope.row.courier_type == 2
                                ? _c("span", [_vm._v("非系统通知")])
                                : _vm._e()
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      635680333
                    )
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.isZhifa && _vm.statusActive === 4 && _vm.canInputTs
                ? _c("el-table-column", {
                    attrs: {
                      prop: "courier_odd_status",
                      label: "物流单号更新状态",
                      width: "120"
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _vm._v(
                                "\n        " +
                                  _vm._s(
                                    _vm._f("courierOddStatus")(
                                      scope.row.courier_odd_status
                                    )
                                  ) +
                                  "\n      "
                              )
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      3701662532
                    )
                  })
                : _vm._e(),
              _vm._v(" "),
              !_vm.isFactory &&
              _vm.statusActive !== 6 &&
              !(_vm.statusActive === 4 && _vm.isZhifaOrFactory)
                ? _c("el-table-column", {
                    attrs: { prop: "print_num", label: "已打印次数" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c(
                                "div",
                                {
                                  on: {
                                    click: function($event) {
                                      return _vm.getDetailTable(scope.row)
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n          " +
                                      _vm._s(scope.row.print_num) +
                                      "\n        "
                                  )
                                ]
                              )
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      31026939
                    )
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  fixed: "right",
                  width:
                    _vm.isZhifaOrFactory &&
                    (_vm.statusActive === 3 || _vm.statusActive === 4)
                      ? 120
                      : 90,
                  label: "操作",
                  align: "center"
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function(scope) {
                        return [
                          _vm.statusActive !== 6
                            ? _c(
                                "el-button",
                                {
                                  staticClass: "rejectOrder",
                                  attrs: { type: "text" },
                                  on: {
                                    click: function($event) {
                                      return _vm.getOrderDetail(scope.row)
                                    }
                                  }
                                },
                                [_vm._v("查看")]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.statusActive === 3 && !_vm.isFactory && _vm.isJgj
                            ? _c(
                                "el-button",
                                {
                                  staticClass: "rejectOrder",
                                  attrs: { type: "text" },
                                  on: {
                                    click: function($event) {
                                      return _vm.editOrderHandler(scope.row.id)
                                    }
                                  }
                                },
                                [_vm._v("编辑")]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.statusActive === 6
                            ? _c(
                                "el-button",
                                {
                                  staticClass: "rejectOrder",
                                  attrs: { type: "text" },
                                  on: {
                                    click: function($event) {
                                      return _vm.createWorkOrder(
                                        scope.row.main_number
                                      )
                                    }
                                  }
                                },
                                [_vm._v("新建工单")]
                              )
                            : _vm._e()
                        ]
                      }
                    }
                  ],
                  null,
                  false,
                  2851646102
                )
              })
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-66646c6e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-66646c6e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/order/order-table.vue
// module id = null
// module chunks = 